module.exports = __webpack_public_path__ + "img/MSCI.b370988b.png";